import createAsyncActionType from "../../../utilities/createAsyncActionType";

// GET
export const GET_CLIENT_PROFILE_ENTRIES = createAsyncActionType(
  "GET_CLIENT_PROFILE_ENTRIES"
);
export const GET_CLIENT_PROFILE_ENTRIES_COUNT = createAsyncActionType(
  "GET_CLIENT_PROFILE_ENTRIES_COUNT"
);

// SET
export const SET_CLIENT_PROFILE_ENTRY_CURRENT_PAGE =
  "SET_CLIENT_PROFILE_ENTRY_CURRENT_PAGE";
export const SET_CLIENT_PROFILE_ENTRY_SEARCH_FILTERS =
  "SET_CLIENT_PROFILE_ENTRY_SEARCH_FILTERS";

// CLEAR
export const CLEAR_CLIENT_PROFILE_ENTRIES = "CLEAR_CLIENT_PROFILE_ENTRIES";

// CREATE
export const CREATE_WATCHLIST_IGNORING_PROPERTY = createAsyncActionType(
  "CREATE_WATCHLIST_IGNORING_PROPERTY"
);

// UPDATE
export const UPDATE_CLIENT_SCORING_RESULT_STATUS = createAsyncActionType(
  "UPDATE_CLIENT_SCORING_RESULT_STATUS"
);

export const SET_ITEMS_PER_PAGE_CLIENT_PROFILE =
  "SET_ITEMS_PER_PAGE_CLIENT_PROFILE";

export const SET_NO_ENTRIES_MESSAGE_CLIENT_PROFILE =
  "SET_NO_ENTRIES_MESSAGE_CLIENT_PROFILE";



// WEBPACK FOOTER //
// ./src/features/client-profile/types/clientProfileEntries.js